export default __webpack_public_path__ + "static/media/color_pencil.ed9a1397.jpg";